export enum FaxRequestedEnum {
  Received = 1,
  OnReview =  2,
  Worked = 3,
  Invalid = 4,
  Blank = 5,
  Repeated = 6,
  Error = 7,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/fax-requested.enum.ts